import React, { Component } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import moment from 'moment-timezone';

import SchedulingShowingStatus from '../components/SchedulingShowingStatus';
import ErrorMessage from '../components/ErrorMessage';
import { removeAssignment, removeSelectedSlot } from '../services/scheduling-journey';
import { trackGTMEvent } from '../utils/gtm';
import timezones from '../../constants/timezones';

const FALLBACK_ERROR_MESSAGE = 'ERR_SHOWINGS_MULTIPLE_STATES';

const getErrorMessage = (error) =>
  [error, get(error, 'message'), get(error, 'error'), get(error, 'error.message'), get(error, 'errors.message')].find(
    (value) => typeof value === 'string' && value,
  );

const getTimezone = (unitState) => timezones[unitState] || moment.tz.guess();

export class ScheduleShowingPublicBooking extends Component {
  state = { errorMessage: null };

  componentDidMount() {
    this.createShowing();
  }

  createShowing = async () => {
    const { history, selectedStartUtc, unitId, unitState } = this.props;
    const timezone = getTimezone(unitState);
    const start = moment.utc(selectedStartUtc).tz(timezone);
    const end = start.clone().add(1, 'hour');

    try {
      const {
        data: { id, error },
      } = await axios.post('/self-tours/api/v1/showing', {
        unit_id: unitId,
        date: start.clone().startOf('day'),
        start_time: start,
        end_time: end,
      });

      if (error) {
        this.showError(getErrorMessage(error) || FALLBACK_ERROR_MESSAGE);
        return;
      }

      removeAssignment(unitId);
      localStorage.removeItem('unit_id');
      trackGTMEvent({
        application: 'self-show',
        event: 'SS_Create_Showing',
      });
      history.push(`/home/${id}`);
    } catch (requestError) {
      const errorMessage = getErrorMessage(get(requestError, 'response.data')) || FALLBACK_ERROR_MESSAGE;
      this.showError(errorMessage);
    }
  };

  showError = (errorMessage) => {
    removeSelectedSlot(String(this.props.unitId));
    this.setState({ errorMessage });
  };

  render() {
    const { selectedStartUtc, unitAddress, unitState } = this.props;
    const { errorMessage } = this.state;

    if (errorMessage) {
      return (
        <ErrorMessage
          padding={{ pt: 32, pb: 48, pl: 0, pr: 0 }}
          type={errorMessage}
          unitId={{ unit_id: String(this.props.unitId) }}
        />
      );
    }

    const timezone = getTimezone(unitState);
    const start = moment.utc(selectedStartUtc).tz(timezone);

    return (
      <SchedulingShowingStatus unitAddress={unitAddress} timeSelected={{ start, end: start.clone().add(1, 'hour') }} />
    );
  }
}

export default ScheduleShowingPublicBooking;
